import Ajv from 'ajv';
import * as GarageScheduledRateScheme from './scheme.json';

const ajv = new Ajv();
export const GarageScheduledRateValidator = ajv.compile(
  GarageScheduledRateScheme,
);
